<div class="flex flex-col sm:flex-row justify-center gap-6 max-w-[70rem]">


    <div>
        @if (!emailSent) {
            <app-email-send-token
                    (emailSubmitted)="onEmailSubmitted($event)"
            >
            </app-email-send-token>
        }
        @if (emailSent) {
            <app-token-email
                    [email]="email"
            >
            </app-token-email>
        }

    </div>
</div>
